import { useSearchModelsApiV1VehiclesModelsGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { ModelSuggestion } from '#/shared/api/generated/shipment/models'
import { useDebouncedValue } from '#/shared/lib/hooks'

export const MODEL_MIN_QUERY_LENGTH = 2
const DEBOUNCE_MS = 250
const SUGGEST_LIMIT = 20

interface UseModelSearchParams {
  make?: string
  query: string
  enabled?: boolean
}

export function useModelSearch({
  make,
  query,
  enabled: enabledOption = true,
}: UseModelSearchParams) {
  const trimmedMake = (make ?? '').trim()
  const debouncedMake = useDebouncedValue(trimmedMake, DEBOUNCE_MS)
  const debouncedQuery = useDebouncedValue(query.trim(), DEBOUNCE_MS)
  const hasMake = debouncedMake.length > 0
  const hasQuery = debouncedQuery.length >= MODEL_MIN_QUERY_LENGTH
  const hasInput = hasMake || hasQuery
  const enabled = enabledOption && hasInput
  const { data, isFetching } = useSearchModelsApiV1VehiclesModelsGet(
    {
      q: hasQuery ? debouncedQuery : null,
      make: hasMake ? debouncedMake : null,
      limit: SUGGEST_LIMIT,
    },
    { query: { enabled } },
  )
  const items: ModelSuggestion[] = data?.data ?? []
  return {
    items,
    isLoading: isFetching && enabled,
    hasMakeFilter: hasMake,
    needsMoreInput: !hasInput,
  }
}
